<template>
  <div class="home net-status-home">
    <Layout
      layoutType="HARDLIST"
      isRevenue="true"
      :pageTitle="$t('menu.standardNode')"
    >
      <BasiceLayout :title="$t('menu.nodeRunStatus')">
        <div class="hardware-content">
          <!-- mac地址搜索 -->
          <div
            class="hardware-search-wrap"
            align='center'
          >
            <span class="search-text">{{$t('noteText')}}</span>
            <el-input class="search-mac-input" v-model="serverNote" placeholder="" @change="search"></el-input>
          </div>
          <!-- 硬件列表 -->
          <el-table
            v-if="nodeConfig !== 'NODATA' && nodeConfig.length"
            :data="nodeConfig"
            align="left"
            empty-text="Loading..."
            style="width: 100%"
          >
            <!-- mac address -->
            <el-table-column
              prop="serverHostname"
              label="主机名"
              align='center'
            >
            </el-table-column>
            <!-- 备注 -->
            <el-table-column
              :label="$t('noteText')"
              align='center'
              prop="serverNote"
            >
            </el-table-column>
            <!-- CPU -->
            <el-table-column
              label="CPU"
              align='center'
              prop="cpu_count"
            >
            </el-table-column>
            <!-- 内存 -->
            <el-table-column
              :label="$t('mem_size')"
              align='center'
              prop="mem_size"
            >
            </el-table-column>
            <!-- 硬盘 -->
            <el-table-column
              :label="$t('storage_size')"
              align='center'
              prop="storage_size"
            >
            </el-table-column>
            <!-- 运营商 -->
            <el-table-column
              :label="$t('operators')"
              align='center'
              prop="operator"
            >
            </el-table-column>
            <!-- 省份-城市 -->
            <el-table-column
              label="省份-城市"
              align='center'
            >
              <template slot-scope="scope">
                <div>{{scope.row.province}}-{{scope.row.city}}</div>
              </template>
            </el-table-column>
            <!-- 带宽 -->
            <el-table-column
              label="带宽"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="scope.row.bandwidthMb">{{scope.row.bandwidthMb}} M</div>
                <div v-else>-</div>
              </template>
            </el-table-column>
            <!-- 服务状态 -->
            <el-table-column
              label="服务状态"
              align='center'
              prop="serverServiceStatus"
            >
            </el-table-column>
             <!-- 在线状态 -->
            <el-table-column
              prop=""
              :label="$t('netStatus')"
              align='center'
            >
              <template slot-scope="scope">
                <div v-if="!scope.row.status">-</div>
                <el-tag
                  v-if="scope.row.status === 'online'"
                  type="success"
                >online</el-tag>
                <el-tag
                  v-if="scope.row.status === 'offline'"
                  type="danger"
                >offline</el-tag>
              </template>
            </el-table-column>
          </el-table>
          <el-table
            v-if="nodeConfig === 'NO_CONTENT'"
            :empty-text="$t('noHardwareTip')"
            style="width: 100%"
          >
          </el-table>
        </div>
      </BasiceLayout>
    </Layout>
  </div>
</template>

<i18n>
{
  "en": {
    
  },
  "zn": {
    
  }
}
</i18n>


<script>
// @ is an alias to /src
import { mapState, mapActions, mapMutations } from "vuex";
import BasiceLayout from "@/components/Common/BasicLayout.vue";
import moment from "moment";
import { Message } from "element-ui";
import { LANG } from "../../../config/contant.js";
import Layout from "@/components/DatePanel/Layout.vue";
import { BytesToM, toFixed } from "@/utils/utils";

export default {
  name: "home",
  components: {
    BasiceLayout,
    Layout
  },
  data() {
    return {
      serverNote: ""
    };
  },
  computed: mapState({
    nodeConfig: state => state.standardNode.nodeConfig,
  }),
  methods: {
    ...mapActions([
      "getStandardNode"
    ]),
    
    // 搜索
    search() {
      let {serverNote} = this;
      this.getStandardNode({ serverNote, deviceInfo: true });
    },
  },
  created() {
    this.getStandardNode({ deviceInfo: true });
  }
};
</script>

<style lang="stylus">


</style>
